import { render } from "./CauHinhThongSo.vue?vue&type=template&id=8477b0f2&ts=true"
import script from "./CauHinhThongSo.vue?vue&type=script&lang=ts"
export * from "./CauHinhThongSo.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/NghienCuuKhoaHoc/NCKH_FontEnd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__